import * as React from 'react';
import Popper from '@mui/material/Popper';
import MenuList from '@mui/material/MenuList';
import { ClickAwayListener, Paper } from '@mui/material';
import CustomMenuItem from './custom-menu-item.component';

export default function CustomPopper({ icon: IconComponent, menuItems, row}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  return (
    <div>
      <IconComponent oaria-describedby={id} type="button" onClick={handleClick} sx={{cursor: "pointer"}} />
      <Popper id={id} open={open} anchorEl={anchorEl} placement="bottom-start" >
        <Paper>
            <ClickAwayListener onClickAway={handleClick}>
                  <MenuList>
                    {menuItems?.map((item, index) => (
                        <CustomMenuItem key={index} icon={item.icon} text={item.text} color={item.color} item={item} row={row}  />
                    ))}
                  </MenuList>
            </ClickAwayListener>
        </Paper>
      </Popper>
    </div>
  );
}
